var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttenderA(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.069 29.887",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.198 10.035a4.837 4.837 0 119.674 0v19.853h5.2V10.035a10.035 10.035 0 10-20.069 0v19.853h5.2z",
    fill: "#287982"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fb4856"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.679 21.674c-.541-.258-.49-3.866 0-4.227s2.906.885 2.906 2.1-2.364 2.385-2.906 2.127zM13.37 21.674c.541-.258.49-3.866 0-4.227s-2.906.885-2.906 2.1 2.363 2.385 2.906 2.127z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.024 18.677a.876.876 0 01.876.876.876.876 0 01-.876.876.876.876 0 01-.876-.876.876.876 0 01.876-.876z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttenderA);
export default ForwardRef;